<div class="pb-0025 txt-15 txt-fw-500 color--gray--006">
  <ng-container >
    <i class="fal fa-solar-system mr-0025 color--purple"
       [matTooltip]="'This section is universal, as are the fields within it. Responses to universal fields are shared across the organization.'"
       *ngIf="group.isUniversal"></i>
  </ng-container>
  <span title="Section: {{group.name}}">{{group.name}}</span>
</div>

<app-applied-tag-category-table *ngFor="let category of group.categories"
                                [target]="target"
                                [campaignId]="campaignId"
                                [category]="category"></app-applied-tag-category-table>
